import { render } from "./ProductsStage.vue?vue&type=template&id=d6f5bbe0&scoped=true"
import script from "./ProductsStage.vue?vue&type=script&lang=js"
export * from "./ProductsStage.vue?vue&type=script&lang=js"

import "./ProductsStage.vue?vue&type=style&index=0&id=d6f5bbe0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6f5bbe0"]])

export default __exports__